<template>
  <div :class="{className}">
    <div class="article-wrapper">
      <h3 class="article-title">
        {{ blockTitle }}
      </h3>
      <ul class="article-block" :class="blockType">
        <li v-for="(item) in articleData" :key="item.id" class="block-list">
          <RouterLink :to="{ name: 'articleById', params: { locale: $i18n.localePath(), id: item.id } }"
                      :class="className.split('-')['1']"
          >
            <div v-cover-lazy-loader class="block-image" :data-src="item.cover" :data-default-src="'/img/cover-social/read.png'">
              <!-- -->
            </div>
            <p class="title">
              {{ item.subject }}
            </p>
          </RouterLink>
        </li>
      </ul>
      <!-- <RouterLink v-for="(item, index) in articleData" :key="index"
                  :to="{ name: 'articleById', params: { locale: $i18n.localePath(), id: item.id }, query: { isSuggested: 1 } }"
                  title="Recommend article" class="recommend"
      >
        <div v-cover-lazy-loader :data-src="item.cover" :data-default-src="'/img/cover-social/read.png'" class="cover">
        </div>
        <div class="info">
          <div class="subject">
            {{ item.subject }}
          </div>
        </div>
      </RouterLink> -->
    </div>
  </div>
</template>

<script>
import CoverLazyLoader from '@/directives/CoverLazyLoader'
// import ArticleService from '@/assets/services/ArticleService'
export default {
  name: 'ArticleRecommend',
  components: {},
  directives: {
    CoverLazyLoader
  },
  props: {
    blockTitle: {
      type: String,
      default: ''
    },
    blockType: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    articleData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
  },
  updated() {},
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.article-title{
  font-size: 24px;
  font-weight: 500;
  line-height: 1.63;
  color: $grey-50;
  margin-top: 24px;
  margin-bottom: 16px;
}
.article-block{
  margin: 0;
  padding: 0;
  &.recommend{
    .block-list{
      display: inline-block;
      vertical-align: top;
      width: 50%;
      .block-image{
        width: 205px;
        height: 108px;
        float: left;
      }
      .title{
        overflow: hidden;
        padding: 0 12px 0 24px;
      }
    }
  }
}
.block-list{
  display: inline-block;
  list-style: none;
  width: 100%;
  margin-bottom: 24px;
  a {
    text-decoration: none;
  }
  .block-image{
    position: relative;
    width: 100%;
    height: 129px;
    overflow: hidden;
    border-radius: 4px;
    background-color: $grey-ec;
    background-image: url('/img/cover-social/read.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .title{
    font-size: 20px;
    font-weight: 500;
    line-height: 1.6;
    max-height: 64px;
    padding-top: 4px;
    @include ellipsis-with-lines(2);
    overflow: hidden;
    margin: 0;
    color: $grey-50
  }
}

@media only screen and (min-width: 1440px) {
  // As same as default
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  // As same as default
  .article-block{
    &.recommend{
      .block-list{
        .block-image{
          width: 12vw;
        }
        .title{
          padding-right: 16px;
        }
      }
    }
  }
}

@media only screen and (max-width: 1023.98px) {
  .article-title{
    margin: 24px 0 16px 0;
  }
  .article-block{
    .block-list{
      display: inline-block;
      width: 50%;
      float: left;
      padding-right: 30px;
      .block-image{
        width: 205px;
        height: 108px;
        float: left;
      }
      .title{
        padding-left: 24px;
        max-height: 94px;
        @include ellipsis-with-lines(3);
      }
    }
    &.recommend{
      .block-list{
        .block-image{
          width: 205px;
          height: 110px;
        }
        .title{
          padding-right: 16px;
        }
      }
    }
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .article-title{
    font-size: 20px;
    margin: 12px 0 6px;
  }
  .article-block{
    &.recommend{
      .block-list{
        width: 100%;
        .block-image{
          width: 110px;
          height: 110px;
        }
        .title{
          padding-right: 16px;
        }
      }
    }
    .block-list{
      display: inline-block;
      width: 100%;
      float: left;
      padding-right: 0;
      margin-bottom: 16px;
      .block-image{
        width: 110px;
        height: 110px;
      }
      .title{
        padding-left: 16px;
      }
    }
  }
}
</style>
